export default __webpack_public_path__ + "static/media/white-lightning.4b30144a.svg";